import { ComponentProps } from 'react';
import { useIntl } from 'react-intl';

import NumberValue from '../NumberValue/NumberValue';

type MoneyValueProps = {
    currencyCode: string;
} & ComponentProps<typeof NumberValue>;

const MoneyValue = ({
    currencyCode,
    hideDecimals,
    ...props
}: MoneyValueProps) => {
    const intl = useIntl();

    return (
        <NumberValue
            {...props}
            customFormatter={(value) =>
                intl.formatNumber(value, {
                    style: 'currency',
                    currency: currencyCode,
                    maximumFractionDigits: hideDecimals ? 0 : 2,
                })
            }
        />
    );
};

export default MoneyValue;
